// outros-resources-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "% de": "% de",
    "* Preview da tela Home *": "* Vista previa de la pantalla de inicio *",
    "* Valores demonstrativos *": "* Valores demostrativos *",
    "1- O envio do arquivo pode demorar até 2 minutos, a depender da conexão de internet.": "1- El envío del archivo puede demorar hasta 2 minutos, según la conexión a internet.",
    "2- Após o envio, processaremos o vídeo para deixá-lo otimizado para ser reproduzido nos dispositivos dos seus clientes. Esta etapa pode levar até 5 minutos.": "2- Después del envío, procesaremos el video para optimizarlo para su reproducción en los dispositivos de sus clientes. Esta etapa puede tardar hasta 5 minutos.",
    "Abastecer": "Cargar combustible",
    "Adicionar Quadro": "Agregar cuadro",
    "Advertisement": "Advertisement",
    "Agendamento": "Programación",
    "Agendamento ativo": "Programación activa",
    "Anúncio": "Anuncio",
    "Anúncio criado com sucesso": "Anuncio creado con éxito",
    "Aprovado": "Aprobado",
    "Arquivo": "Archivo",
    "Ativar agendamento": "Activar programación",
    "Ativo": "Activo",
    "Ativo?": "¿Activo?",
    "Build": "Build",
    "Cadastrar anúncio": "Registrar anuncio",
    "Cadastrar novo envio recorrente": "Registrar nuevo envío recurrente",
    "Cadastrar novo envio único": "Registrar nuevo envío único",
    "Cadastrar quadro": "Registrar cuadro",
    "Campanha": "Campaña",
    "Canais e Mensagens": "Canales y mensajes",
    "Canal": "Canal",
    "Carregando...": "Cargando...",
    "Categoria de clientes": "Categoría de clientes",
    "Celular": "Celular",
    "Cliente": "Cliente",
    "Clientes da rede que se encaixam na segmentação configurada e possuem o app instalado (token de notificação válido). Na etiqueta de posto, entram os clientes cujo primeiro abastecimento foi em um posto da etiqueta — o mesmo critério do relatório \"Primeiro Abastecimento por Posto\", com a diferença de que aqui só aparece quem tem o app. Esta é uma prévia atualizada — a lista real pode variar a cada disparo conforme novos cadastros e tokens.": "Clientes de la red que cumplen con la segmentación configurada y tienen la aplicación instalada (token de notificación válido). En la etiqueta de estación, se incluyen los clientes cuya primera carga de combustible fue en una estación de la etiqueta — el mismo criterio del reporte \"Primera Carga de Combustible por Estación\", con la diferencia de que aquí solo aparece quien tiene la aplicación. Esta es una vista previa actualizada — la lista real puede variar en cada envío según nuevos registros y tokens.",
    "Clientes que receberão": "Clientes que recibirán",
    "Cliques": "Clics",
    "Clonar": "Clonar",
    "Commits:": "Commits:",
    "Configuração Mix": "Configuración Mix",
    "Configuração de textos no aplicativo": "Configuración de textos en la aplicación",
    "Continuar": "Continuar",
    "Criado em": "Creado el",
    "Criado por": "Creado por",
    "Código": "Código",
    "Data": "Fecha",
    "Data Fim": "Fecha de fin",
    "Data Final": "Fecha final",
    "Data Início": "Fecha de inicio",
    "Data de Envio": "Fecha de envío",
    "Data de fim": "Fecha de fin",
    "Data de início": "Fecha de inicio",
    "Data do envio": "Fecha del envío",
    "Data final": "Fecha final",
    "Data inicial": "Fecha inicial",
    "Descrição (exibida no app)": "Descripción (mostrada en la aplicación)",
    "Descrição da regra": "Descripción de la regla",
    "Dia": "Día",
    "Dias da semana": "Días de la semana",
    "Disparos realizados": "Envíos realizados",
    "Duração (segundos)": "Duración (segundos)",
    "E-mail": "E-mail",
    "ETANOL": "ETANOL",
    "Editar envio recorrente": "Editar envío recurrente",
    "Editar envio único": "Editar envío único",
    "Editar versão do app": "Editar versión de la aplicación",
    "Enviado": "Enviado",
    "Envio Recorrente": "Envío recurrente",
    "Envio pausado": "Envío pausado",
    "Envios Recorrentes": "Envíos recurrentes",
    "Envios Únicos": "Envíos únicos",
    "Erro ao alterar status": "Error al cambiar el estado",
    "Etiqueta de cliente": "Etiqueta de cliente",
    "Etiqueta de posto": "Etiqueta de estación",
    "Falha ao processar o vídeo tente novamante": "Error al procesar el video, intente nuevamente",
    "Fim": "Fin",
    "Fim em": "Finaliza el",
    "Gasolina Comum": "Gasolina Común",
    "Grupo de Clientes": "Grupo de clientes",
    "Habilitar": "Habilitar",
    "Histórico de disparos gerados por este envio recorrente — cada execução agendada cria um registro por canal (Push e/ou SMS) com o status atual e contagens de envio.": "Historial de envíos generados por este envío recurrente — cada ejecución programada crea un registro por canal (Push y/o SMS) con el estado actual y los conteos de envío.",
    "Hora de fim": "Hora de fin",
    "Hora de inicio": "Hora de inicio",
    "Horário": "Horario",
    "Horário final": "Horario final",
    "Horário inicial": "Horario inicial",
    "Horários": "Horarios",
    "Horários Semanais": "Horarios semanales",
    "Informação:": "Información:",
    "Informações": "Información",
    "Informações Básicas": "Información básica",
    "Inicio": "Inicio",
    "Inicio em": "Inicia el",
    "Intervalo (dias)": "Intervalo (días)",
    "Início": "Inicio",
    "João Silva": "Juan Pérez",
    "Label do saldo de cashback": "Etiqueta del saldo de cashback",
    "Label do saldo de pontos": "Etiqueta del saldo de puntos",
    "Lançamento": "Lanzamiento",
    "Lidos": "Leídos",
    "Manual de Meta de Frentista": "Manual de objetivo del playero",
    "Mensagem": "Mensaje",
    "Meta:": "Objetivo:",
    "Metas": "Objetivos",
    "Modo TV": "Modo TV",
    "Monitoramento de quadro": "Monitoreo de cuadro",
    "Mostrar sem progresso": "Mostrar sin progreso",
    "Máximo 60 dias": "Máximo 60 días",
    "Mínimo / Meta": "Mínimo / objetivo",
    "Nenhum quadro adicionado": "Ningún cuadro agregado",
    "Nome do quadro": "Nombre del cuadro",
    "Notas": "Notas",
    "Notas (PT)": "Notas (PT)",
    "Notificação": "Notificación",
    "Notificação pelo app": "Notificación por la aplicación",
    "Não feche ou saia dessa janela.": "No cierre ni salga de esta ventana.",
    "Não foi possível realizar a operação, tente novamente": "No fue posible realizar la operación, intente nuevamente",
    "O vídeo ainda está sendo processado, aguarde alguns minutos...": "El video aún se está procesando, espere unos minutos...",
    "Olá,": "Hola,",
    "Os vídeos serão reproduzidos sem áudio no aplicativo": "Los videos se reproducirán sin audio en la aplicación",
    "Pendente": "Pendiente",
    "Perfil": "Perfil",
    "Preset": "Preset",
    "Preview": "Vista previa",
    "Preço por litro": "Precio por litro",
    "Prioridade": "Prioridad",
    "Push": "Push",
    "Quadro criado com sucesso": "Cuadro creado con éxito",
    "R$ 0,10 DE DESCONTO": "R$ 0,10 DE DESCUENTO",
    "R$ 20,00": "R$ 20,00",
    "R$ 9,99": "R$ 9,99",
    "R$ adicional": "R$ adicional",
    "R$ fixo": "R$ fijo",
    "Recebidos": "Recibidos",
    "Regras de Segurança": "Reglas de seguridad",
    "Remover": "Quitar",
    "Remover quadro": "Quitar cuadro",
    "Resgatar": "Canjear",
    "Resgate": "Canje",
    "Resgates ilimitados": "Canjes ilimitados",
    "Resumo": "Resumen",
    "Sair do Modo TV (ESC)": "Salir del modo TV (ESC)",
    "Selecionar todos os combustíveis": "Seleccionar todos los combustibles",
    "Selecionar todos os postos": "Seleccionar todas las estaciones",
    "Selecione um posto": "Seleccione una estación",
    "Selecione uma Rede": "Seleccione una red",
    "Selecione uma rede": "Seleccione una red",
    "Selecione uma rede para fazer alterações": "Seleccione una red para realizar cambios",
    "Selecione uma rede para visualizar as informações": "Seleccione una red para visualizar la información",
    "Sem segmentação — todos os clientes da rede com app instalado serão alcançados.": "Sin segmentación — todos los clientes de la red con la aplicación instalada serán alcanzados.",
    "Serão debitados 10 pontos ao aplicar essa oferta": "Se debitarán 10 puntos al aplicar esta oferta",
    "Seu arquivo está sendo processado.": "Su archivo se está procesando.",
    "Seu navegador não suporta vídeos.": "Su navegador no admite videos.",
    "Sexo": "Sexo",
    "Sexo do cliente": "Sexo del cliente",
    "Status": "Estado",
    "Tela de Descontos": "Pantalla de descuentos",
    "Tela inicial": "Pantalla inicial",
    "Tipo": "Tipo",
    "Tipo de envio": "Tipo de envío",
    "Titulo": "Título",
    "Total": "Total",
    "Título da seção de produtos em dinheiro": "Título de la sección de productos en dinero",
    "Unid. adicional": "Unid. adicional",
    "Usuário": "Usuario",
    "Valor em reais": "Valor en reales",
    "Valor mínimo": "Valor mínimo",
    "Versão": "Versión",
    "Versão do app": "Versión de la aplicación",
    "Visualização": "Visualización",
    "combustíve": "combustible",
    "no total de": "del total de",
    "próxima atualização": "próxima actualización",
    "ra.notification.data_provider_error": "ra.notification.data_provider_error",
    "ra.notification.updated": "ra.notification.updated",
};

export default catalogo;
